// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderRightOutlinedSvg from "@fishx/icons-svg/es/asn/BorderRightOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderRightOutlined = function BorderRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderRightOutlinedSvg
  }));
};

BorderRightOutlined.displayName = 'BorderRightOutlined';
export default React.forwardRef(BorderRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderRightOutlined.js
// module id = 2097
// module chunks = 0